import { useEffect, useState } from "react";
import { getConsent, onConsentChange } from "@/lib/cookieConsent";

/**
 * Loads Google Analytics (gtag.js) only when the user has granted analytics consent.
 * Reacts to consent changes in real time.
 */
export function GAConsentLoader({ gaId }: { gaId: string | null }) {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const sync = () => {
      const c = getConsent();
      setAllowed(!!c?.categories.analytics);
    };
    sync();
    return onConsentChange(sync);
  }, []);

  useEffect(() => {
    if (!gaId || !allowed) return;
    if (typeof document === "undefined") return;

    // Avoid double-injection.
    const existing = document.querySelector<HTMLScriptElement>(
      `script[data-ga-id="${gaId}"]`
    );
    if (existing) return;

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
    s.dataset.gaId = gaId;
    document.head.appendChild(s);

    const inline = document.createElement("script");
    inline.dataset.gaInit = gaId;
    inline.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${gaId.replace(
      /'/g,
      ""
    )}',{anonymize_ip:true});`;
    document.head.appendChild(inline);
  }, [gaId, allowed]);

  return null;
}
